import { useState } from 'react';
import { Bell, Check, CheckCheck, Trash2, Clock } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';

export default function BildirimDropdown({ ustaId }) {
  const [acik, setAcik] = useState(false);
  const { notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications(ustaId);

  const handleMarkAsRead = async (e, id) => {
    e.stopPropagation();
    await markAsRead(id);
  };

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
  };

  const formatTarih = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="relative">
      {/* Bildirim Zili */}
      <button
        onClick={() => setAcik(!acik)}
        className="relative p-2.5 bg-zinc-900 rounded-xl text-zinc-500 hover:text-white transition-colors"
      >
        <Bell size={20} />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-[10px] font-black rounded-full flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {/* Dropdown */}
      {acik && (
        <>
          <div 
            className="fixed inset-0 z-[90]" 
            onClick={() => setAcik(false)} 
          />
          <div className="absolute right-0 top-full mt-2 w-80 bg-stone-900 border border-stone-800 rounded-2xl shadow-2xl z-[100] overflow-hidden">
            {/* Header */}
            <div className="px-4 py-3 border-b border-stone-800 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Bell size={14} className="text-stone-500" />
                <span className="text-xs font-black text-white uppercase tracking-wider">Bildirimler</span>
              </div>
              {notifications.length > 0 && (
                <button
                  onClick={handleMarkAllAsRead}
                  className="text-[10px] text-stone-500 hover:text-emerald-400 font-bold flex items-center gap-1 transition-colors"
                >
                  <CheckCheck size={12} /> Tümünü oku
                </button>
              )}
            </div>

            {/* Liste */}
            <div className="max-h-80 overflow-y-auto">
              {notifications.length === 0 ? (
                <div className="px-4 py-8 text-center">
                  <Bell size={32} className="text-stone-700 mx-auto mb-2" />
                  <p className="text-xs text-stone-600 font-bold">Bildirim yok</p>
                </div>
              ) : (
                notifications.map(notif => (
                  <div
                    key={notif.id}
                    className="px-4 py-3 border-b border-stone-800/50 hover:bg-stone-800/30 transition-colors"
                  >
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-lg bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Bell size={14} className="text-emerald-400" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-bold text-white truncate">{notif.title}</p>
                        <p className="text-xs text-stone-400 mt-0.5 leading-relaxed">{notif.body}</p>
                        <div className="flex items-center gap-2 mt-2">
                          <Clock size={10} className="text-stone-600" />
                          <span className="text-[10px] text-stone-600 font-bold">{formatTarih(notif.createdAt)}</span>
                        </div>
                      </div>
                      <button
                        onClick={(e) => handleMarkAsRead(e, notif.id)}
                        className="p-1.5 text-stone-600 hover:text-emerald-400 hover:bg-stone-800 rounded-lg transition-all flex-shrink-0"
                        title="Okundu olarak işaretle"
                      >
                        <Check size={14} />
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}